<style scoped>
    .iframe-container {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 95%;
        /* height: 840px !important; */
        /* padding-top: 56.25%; 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    }
    
    .responsive-iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        /* height: 840px !important; */
    }

    .button-width {
        width: 8.33% !important;
        min-width: fit-content;
    }
</style>

<template>
    <!-- <ModalComponent ref="modal" :title="`Apercu - ${filename}`" size="modal-xl" :confirm="true" :prevent-modal-movement="true" height="90vh"> -->
        <div class="row mb-2">
            <div class="btn-group btn-group-xs col-1 button-width">
                <button class="btn btn-light w-fit p-2 flex-center" v-tooltip data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="$t('general.download')"
                        data-bs-trigger="hover" @click.prevent="downloadPDF()">
                        <span class="d-flex d-lg-none flex-center">
                            <i class="fa-solid fa-download fa-xs"></i>
                        </span>
                        <i class="fa-solid fa-download fa-xs d-none d-lg-flex flex-center"></i>
                </button>
                <button class="btn btn-light d-none d-lg-flex flex-center" v-tooltip data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="$t('general.print')"
                        data-bs-trigger="hover" @click.prevent="printPDF()">
                    <i class="fa-solid fa-print fa-xs"></i>
                </button>
            </div>
            <div class="btn-group btn-group-xs col-2 d-none d-lg-flex">
                <button class="btn btn-light btn-xs" v-tooltip data-bs-toggle="tooltip" data-bs-placement="top" :data-bs-title="$t('general.resetZoom')"
                        data-bs-trigger="hover" @click.prevent="zoom = 100; refreshIframe()">
                    <i class="fa-solid fa-magnifying-glass fa-xs"></i>
                </button>
                <button class="btn btn-light" @click.prevent="zoom += zoomChange">
                    <i class="fa-solid fa-magnifying-glass-plus fa-xs"></i>
                </button>
                <button class="btn btn-light" @click.prevent="zoom -= zoomChange">
                    <i class="fa-solid fa-magnifying-glass-minus fa-xs"></i>
                </button>
            </div>
            <div class="col d-none d-lg-flex">
                Zoom {{ zoom }}%
            </div>
        </div>
        <div class="iframe-container">
            <iframe ref="iframePDF"
            v-if="pdfUrl"
            :src="generatedURL"
            class="responsive-iframe"
            style="border: none;"
            title="PDFViewer"
            ></iframe>
        </div>
    <!-- </ModalComponent> -->
</template>

<script>
    import ModalComponent from "@/components/_shared/ModalComponent.vue";

    export default {
        name: "PDFViewer",
        components: {ModalComponent},
        props: {},
        data() {
            return {
                pdfUrl: null,
                pdfBlob: null,
                filename: "document.pdf",
                zoom: 100,
                zoomChange: 17.5,
            }
        },
        computed: {
            generatedURL() {
                this.$nextTick(() => { this.refreshIframe() });
                return `${this.pdfUrl}#toolbar=0&zoom=${this.zoom}`;
            },
        },
        methods: {
            open(response, filename, receivedAsBlob = true) {
                const newBlob = new Blob( receivedAsBlob ? [response.data] : [response], { type: 'application/pdf' });
                this.filename = filename;

                this.createObjectUrl(newBlob);
                // this.$refs.modal.open();
            },
            createObjectUrl(blob) {
                this.closing();
                this.pdfUrl = URL.createObjectURL(blob);
            },
            closing() {
                if (this.pdfUrl) {
                    URL.revokeObjectURL(this.pdfUrl);
                    this.pdfUrl = null;
                    this.pdfBlob = null;
                    this.filename = "document.pdf";
                }
                this.zoom = 100;
            },
            downloadPDF() {
                const link = document.createElement('a');
                link.href = this.pdfUrl;
                link.download = this.filename;
                link.click();
            },
            printPDF() {
                this.$refs.iframePDF.contentWindow.print();
            },
            refreshIframe() {
                this.$refs.iframePDF?.contentWindow.location.reload(true);
            },
        },
        watch: {},
    }
</script>
